/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { sendRequestAndReceiveResponse, filterNames, filterModels } from '../common/common';
import { getConstantsDetailonNameEndPoint } from '../common/constants';

const UPDATE_INSTRUMENTCONSTANTS_SELECTED_FAMILIES = 'UPDATE_INSTRUMENTCONSTANTS_SELECTED_FAMILIES';
const UPDATE_INSTRUMENTCONSTANTS_SELECTED_PRODUCTNAMES = 'UPDATE_INSTRUMENTCONSTANTS_SELECTED_PRODUCTNAMES';
const UPDATE_INSTRUMENTCONSTANTS_SELECTED_PRODUCTMODELS = 'UPDATE_INSTRUMENTCONSTANTS_SELECTED_PRODUCTMODELS';

const CONSTANTS = 'CONSTANTS';
const CLEAR_UPLOAD_CONSTANTS_STORE = 'CLEAR_UPLOAD_CONSTANTS_STORE';
const HANDLE_UPLOAD_DIALOG_CLICK = 'HANDLE_UPLOAD_DIALOG_CLICK';

const UPDATE_FILE_NAME = 'UPDATE_FILE_NAME';
const UPDATE_FILE_TYPE = 'UPDATE_FILE_TYPE';

const LOADING_CONSTANTS_DETAIL_ON_NAME = 'LOADING_CONSTANTS_DETAIL_ON_NAME';
const UPDATE_INSTRUMENTCONSTANTS_UPLOAD_FAMILIES = 'UPDATE_INSTRUMENTCONSTANTS_UPLOAD_FAMILIES';
const UPDATE_INSTRUMENTCONSTANTS_UPLOAD_NAMES = 'UPDATE_INSTRUMENTCONSTANTS_UPLOAD_NAMES';
const UPDATE_INSTRUMENTCONSTANTS_UPLOAD_MODELS = 'UPDATE_INSTRUMENTCONSTANTS_UPLOAD_MODELS';

const colors: Array<string> = ['#CFE1EE', '#DFE9D6', '#FFF2CC', '#FFE8CC', '#F4D1D3'];

const initialState = {
    data: {},
    uploadDialogOpen: false,
    isDetailLoadingOnConstantName: false,
    uploadDetails: { families: [], productNames: [], productModels: [] },
    isFileChanged: false,
}

export const actionCreators = {
    UpdateUploadFamilies: (families: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_INSTRUMENTCONSTANTS_UPLOAD_FAMILIES, families });
    },
    UpdateSelectedFamilies: (selectedFamilies: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_INSTRUMENTCONSTANTS_SELECTED_FAMILIES, selectedFamilies });
    },
    FilterUploadNames: (productFamilies: any, selectedFamilies: any) => async (dispatch: any, getState: any) => {
        const productNames: any = filterNames(productFamilies, selectedFamilies);
        dispatch({ type: UPDATE_INSTRUMENTCONSTANTS_UPLOAD_NAMES, productNames });
    },
    UpdateSelectedProductNames: (SelectedProductNames: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_INSTRUMENTCONSTANTS_SELECTED_PRODUCTNAMES, SelectedProductNames });
    },
    FilterUploadModels: (productNames: any, selectedProductNames: any) => async (dispatch: any, getState: any) => {
        const productModels: any = filterModels(productNames, selectedProductNames);
        dispatch({ type: UPDATE_INSTRUMENTCONSTANTS_UPLOAD_MODELS, productModels });
    },
    UpdateSelectedProductModels: (SelectedProductModels: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_INSTRUMENTCONSTANTS_SELECTED_PRODUCTMODELS, SelectedProductModels });
    },

    UpdateSelectedPdf: (selectedPdf: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: CONSTANTS, selectedPdf });
    },
    UpdateFileType: (fileType: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_FILE_TYPE, fileType });
    },
    clearAll: () => async (dispatch: any, getState: any) => {
        dispatch({ type: CLEAR_UPLOAD_CONSTANTS_STORE });
    },
    handleUploadDialogClick: (isOpen: boolean) => async (dispatch: any, getState: any) => {
        dispatch({ type: HANDLE_UPLOAD_DIALOG_CLICK, isOpen });
    },
    UpdateFileName: (fileName: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_FILE_NAME, fileName });
        let a = { value: true };
        dispatch({ type: LOADING_CONSTANTS_DETAIL_ON_NAME, a });
        const constantsData = await sendRequestAndReceiveResponse(JSON.stringify({ "FileName": fileName }), getConstantsDetailonNameEndPoint);
        a = { value: false };
        dispatch({ type: LOADING_CONSTANTS_DETAIL_ON_NAME, a });
    },
}

const getColors = (parentArray: any, selectedArray: any, fillArrayName: any) => {
    const selectedColors: any = [];
    parentArray.map((x: any) => {
        const a: any = selectedArray.indexOf(x.id);
        if (a != -1) {
            if (fillArrayName != '') {
                x.color = colors[a % colors.length];
                x[fillArrayName].forEach((y: any) => {
                    y.color = x.color;
                });
            }
            selectedColors.push(x.color);
        }
    });
    return selectedColors;
};
const getProductNames = (families: any, smd: any) => {
    const productNames: any = [];
    smd.familyData.forEach((family: any) => {
        const a = filterNames(families, [family.productFamilyId]);
        a.forEach((v: any) => {
            productNames.push(v);
        });
    });

    return productNames;
};

export const reducer = (state: any, action: any) => {
    state = state || initialState;

    switch (action.type) {
        case UPDATE_INSTRUMENTCONSTANTS_SELECTED_FAMILIES:
            return {
                ...state,
                selectedFamilies: action.selectedFamilies,
            };
        case UPDATE_INSTRUMENTCONSTANTS_SELECTED_PRODUCTNAMES:
            const selectedNameColors: any = getColors(state.uploadDetails.productNames, action.SelectedProductNames, 'twodproductmodels');
            return {
                ...state,
                selectedProductNames: action.SelectedProductNames,
                selectedNameColors
            };
        case UPDATE_INSTRUMENTCONSTANTS_SELECTED_PRODUCTMODELS:
            const selectedModelColors: any = getColors(state.uploadDetails.productModels, action.SelectedProductModels, '');
            let dn: any = '';

            if (state.isFileChanged || state.isEdit) {
                dn = state.displayName;
            }
            else {
                let tempstring: any = '';
                state.uploadDetails.productModels.map((x: any) => {
                    if (action.SelectedProductModels.indexOf(x.id) != -1) {
                        tempstring += ', ' + x.name;
                    }
                });
                dn = tempstring.substring(1);
            }

            return {
                ...state,
                selectedProductModels: action.SelectedProductModels,
                selectedModelColors,
                displayName: dn
            };
        case CONSTANTS:
            return {
                ...state,
                selectedPdf: action.selectedPdf
            };
        case CLEAR_UPLOAD_CONSTANTS_STORE:
            return initialState;
        case HANDLE_UPLOAD_DIALOG_CLICK:
            return {
                ...state,
                uploadDialogOpen: action.isOpen
            };
        case UPDATE_FILE_TYPE:
            return {
                ...state,
                fileType: action.fileType
            };
        case UPDATE_FILE_NAME:
            return {
                ...state,
                fileName: action.fileName
            };
        case LOADING_CONSTANTS_DETAIL_ON_NAME:
            return {
                ...state,
                isDetailLoadingOnConstantName: action.a.value
            };
        case UPDATE_INSTRUMENTCONSTANTS_UPLOAD_FAMILIES:
            return {
                ...state,
                uploadDetails: { ...state.uploadDetails, families: action.families }
            };
        case UPDATE_INSTRUMENTCONSTANTS_UPLOAD_NAMES:
            return {
                ...state,
                uploadDetails: { ...state.uploadDetails, productNames: action.productNames }
            };
        case UPDATE_INSTRUMENTCONSTANTS_UPLOAD_MODELS:
            return {
                ...state,
                uploadDetails: { ...state.uploadDetails, productModels: action.productModels }

            };

    }
    return state;
};
